import React from "react";
import "../../styles/aboutUs.css"; // Ensure this path matches your structure

const AboutUs = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        
        {/* LEFT SIDE: IMAGE */}
        <div className="about-image-side">
          <img 
            src="https://i.pinimg.com/736x/6a/7a/15/6a7a150b675aeb0ed2b1995aa74ceb25.jpg" 
            alt="Global Business Concept" 
            className="about-img"
          />
        </div>

        {/* RIGHT SIDE: TEXT */}
        <div className="about-text-side">
          <h2 className="about-title">Why Global Certifications?</h2>
          
          <p className="about-description">
            At Madhi Academy – Global Courses Division, we specialize in guiding 
            ambitious professionals towards internationally recognized qualifications like 
            US CPA, US CMA, and EA.
          </p>
          
          <p className="about-sub-description">
            With expert faculty, comprehensive study resources, and career-focused mentoring, 
            we empower students to achieve success in global accounting, finance, and taxation. 
            Our mission is simple: to transform local talent into global professionals.
          </p>

          {/* FEATURE LIST */}
          <div className="about-features">
            
            <div className="feature-item">
              <div className="icon-square">
                <i className="bi bi-book"></i> {/* Book Icon */}
              </div>
              <span className="feature-text">
                <strong>International Recognition</strong> – Stand out in the global job market.
              </span>
            </div>

            <div className="feature-item">
              <div className="icon-square">
                <i className="bi bi-book"></i>
              </div>
              <span className="feature-text">
                <strong>High Salary Potential</strong> – Skilled professionals are in high demand worldwide.
              </span>
            </div>

            <div className="feature-item">
              <div className="icon-square">
                <i className="bi bi-book"></i>
              </div>
              <span className="feature-text">
                <strong>Mobility & Flexibility</strong> – Work across countries and industries.
              </span>
            </div>

            <div className="feature-item">
              <div className="icon-square">
                <i className="bi bi-book"></i>
              </div>
              <span className="feature-text">
                <strong>Specialized Knowledge</strong> – Gain skills in global accounting, finance, and taxation.
              </span>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutUs;